module.exports = __webpack_public_path__ + "components/country-flag/static/nc-26f966c68d9ff9b736a239b3e8c024fd.svg";